import React from "react";
import VisitorTypeTableApp from "../Functionality/VisitorTypeTableApp";
import NotInformation from "../../../../../components/NotInformation";
import routes from "../../../../../Routes/routes";
import {permissionObj} from "../../../../../Helpers/permission";
import CustomExpandableTable from "../../../../../components/table/CustomExpandableTable";
import SearchSimple from "../../../../../components/SearchSimples/SearchSimple";
import DeleteModal from "../../../../Modals/DeleteModal";

/**
 * @email kpozos@ibl.mx
 * @author Karen Yunuen Pozos Arias
 * @title Full Stack Developer
 * @component VisitorTypeTable
 * @description Component that renders the visitor types table with search,
 *              expandable rows, permissions-based action menus, and deletion modal.
 *
 * @param {boolean} props.deleteModal - Flag to show/hide the delete confirmation modal.
 * @param {function} props.setDeleteModal - Setter to toggle the delete modal visibility.
 * @param {Array} props.selectedList - List of currently selected visitor type IDs.
 * @param {function} props.setSelectedList - Setter for the selectedList state.
 *
 * @returns {JSX.Element} The rendered VisitorTypeTable component.
 */

const VisitorTypeTable = (props) => {
    const {
        selectedList,
        setSelectedList,
        setDeleteModal,
        modified,
        setModified
    } = props;
    const {
        t,
        DEV,
        permission,
        columns,
        results,
        setResults,
        searchElement,
        setSearchElement,
        setSearch,
        option,
        searchId,
        page,
        rowsPerPage,
        simpleSearch,
        setSimpleSearch,
        setBodyForExport,
        contractorId,
        supplierId,
        pagination,
        handleCheckboxChange,
        handleDeleteAll,
        renderOptionsMenu,
        handleRowExpand,
        renderExpandedRow
    } = VisitorTypeTableApp({
        setDeleteModal,
        selectedList,
        setSelectedList,
        modified,
        setModified
    });


    return (
        <>
            <SearchSimple
                id={searchId}
                setBodyForExport={setBodyForExport}
                setSearchResults={setResults}
                searchResults={results}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                simpleSearch={simpleSearch}
                setSimpleSearch={setSimpleSearch}
                contractorId={contractorId}
                supplierId={supplierId}

            />
            {results?.content?.length > 0 ? (
                    <>
                        <CustomExpandableTable
                            columns={columns}
                            rows={results?.content || []}
                            renderExpandedRow={renderExpandedRow}
                            onRowExpand={handleRowExpand}
                            renderOptionsMenu={( DEV || permission?.includes(permissionObj?.WEB_VISITOR_TYPE_UPDATE) || permission?.includes(permissionObj?.WEB_VISITOR_TYPE_DELETE) ) ? renderOptionsMenu :  false}
                            selectedList={selectedList}
                            handleCheckboxChange={handleCheckboxChange}
                            handleDeleteAll={handleDeleteAll}
                        />
                        {pagination()}
                    </>
                ) :
                <NotInformation
                    card={true}
                    text={typeof results?.content === "undefined" ? t('loading') : t('no_visitor_types_request_text')}
                    showButton={((DEV || permission?.includes(permissionObj?.WEB_VISITOR_TYPE_CREATE)) && results?.content?.length === 0)}
                    buttonId={'btn_a_link_create'}
                    buttonUrl={routes.visitorType.create}
                    buttonTrans={'created_visitor_types_request'}
                    searchElement={searchElement !== ''}
                />
            }
        </>
    );
};

export default VisitorTypeTable;
